module.exports = __webpack_public_path__ + "static/media/WEB2.9d4f66b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/web/WEB2.jpg
// module id = 81
// module chunks = 0